import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Button } from 'primereact/button';

export default function SummaryCard({
  hideAISummary,
  isSummaryExpanded,
  setIsSummaryExpanded,
  handleDownload,
  playingAudioId,
  isPlaying,
  handleReadAloud,
  handleRestartAudio,
  seekAudio,
  stopAudio,
  uploadResponse,
  setShowShareModal,
}) {
  if (hideAISummary) return null;
  return (
    <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl border border-gray-200/50 overflow-hidden hover:shadow-2xl transition-shadow duration-300 mb-6 md:mb-8">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 p-4 md:p-5 border-b border-gray-200/50 bg-gradient-to-r from-gray-50 to-blue-50/30">
        <div
          className="flex items-center gap-3 cursor-pointer flex-1 group"
          onClick={() => setIsSummaryExpanded(!isSummaryExpanded)}
        >
          <div className="p-2 bg-gradient-to-br from-blue-500 to-purple-600 rounded-lg shadow-md">
            <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <h2 className="text-base md:text-lg font-bold text-gray-800 tracking-wide group-hover:text-blue-600 transition-colors">AI-GENERATED SUMMARY</h2>
          <svg
            className={`w-5 h-5 text-gray-400 transition-all duration-300 group-hover:text-blue-600 ${isSummaryExpanded ? 'rotate-180' : ''}`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
          </svg>
        </div>

        <div className="flex items-center gap-2">
          <Button
            icon="pi pi-download"
            label="PDF"
            className="p-button-sm p-button-outlined border-2 font-semibold text-gray-700 hover:bg-gray-50 hover:border-gray-400 transition-all duration-200"
            onClick={() => handleDownload('pdf')}
          />
          <Button
            icon="pi pi-share-alt"
            label="Share"
            className="p-button-sm p-button-outlined border-2 font-semibold text-green-600 hover:bg-green-50 hover:border-green-400 transition-all duration-200"
            onClick={() => setShowShareModal(true)}
          />

          {playingAudioId === 'summary' && (
            <div className="flex items-center gap-2 bg-blue-50 px-3 py-1.5 rounded-lg border border-blue-200">
              <Button
                icon="pi pi-replay"
                className="p-button-text p-button-sm text-blue-600 hover:bg-blue-100 w-8 h-8"
                onClick={handleRestartAudio}
                tooltip="Restart from beginning"
                tooltipOptions={{ position: 'top' }}
              />
              <Button
                icon="pi pi-step-backward"
                className="p-button-text p-button-sm text-blue-600 hover:bg-blue-100 w-8 h-8"
                onClick={() => seekAudio(-10)}
                tooltip="Rewind 10s"
                tooltipOptions={{ position: 'top' }}
              />
              <Button
                icon={isPlaying ? "pi pi-pause" : "pi pi-play"}
                className="p-button-rounded p-button-sm bg-blue-600 text-white hover:bg-blue-700 w-9 h-9 border-0 shadow-md"
                onClick={handleReadAloud}
                tooltip={isPlaying ? "Pause" : "Resume"}
                tooltipOptions={{ position: 'top' }}
              />
              <Button
                icon="pi pi-step-forward"
                className="p-button-text p-button-sm text-blue-600 hover:bg-blue-100 w-8 h-8"
                onClick={() => seekAudio(10)}
                tooltip="Forward 10s"
                tooltipOptions={{ position: 'top' }}
              />
              <Button
                icon="pi pi-stop"
                className="p-button-text p-button-sm text-red-600 hover:bg-red-50 w-8 h-8"
                onClick={stopAudio}
                tooltip="Stop"
                tooltipOptions={{ position: 'top' }}
              />
            </div>
          )}

          {!playingAudioId && (
            <Button
              icon="pi pi-volume-up"
              label="READ ALOUD"
              className="p-button-outlined p-button-sm border-2 hover:bg-blue-50 hover:border-blue-400 font-semibold text-blue-600 transition-all duration-200"
              onClick={handleReadAloud}
            />
          )}
        </div>
      </div>

      {isSummaryExpanded && (
        <div className="p-6 bg-gradient-to-b from-white to-gray-50/30">
          <div className="inline-block bg-amber-50 border-l-4 border-amber-400 px-4 py-2 rounded-r-lg mb-6">
            <p className="text-sm text-amber-800 font-medium">For healthcare professional use only.</p>
          </div>
          {uploadResponse?.detailed_summary ? (
            <div className="prose prose-lg max-w-none prose-headings:text-gray-800 prose-p:text-gray-600 prose-strong:text-gray-800">
              <ReactMarkdown remarkPlugins={[remarkGfm]}>{uploadResponse.detailed_summary}</ReactMarkdown>
            </div>
          ) : (
            <div className="space-y-6"></div>
          )}
        </div>
      )}
    </div>
  );
}